import React from 'react';

const Pagination =(props) => {


const pageLinks = []

// Take the number of pages and do a for loop to create a li tag with the corrent number associated with that page number
for(let i=1; i <= props.pages + 1; i++) {
    let active = props.currentPage === i ? 'active' : '';

    pageLinks.push(<li className={`page-item ${active}`} key={i} onClick={()=>props.nextPage(i)}><button className='page-link'>{i}</button></li>)
}

    return (
   
        <div className='container pag'>
            <div className="row">
                <ul className='pagination'>
                    {props.currentPage > 5 ? <li className={`page-item`} onClick={()=>props.nextPage(props.currentPage - 5)}><button className='page-link'><i className="fas fa-backward"></i></button></li> : '' }
                    {props.currentPage > 1 ? <li className={`page-item`} onClick={()=>props.nextPage(props.currentPage - 1)}><button className='page-link'>Prev</button></li> : '' }
                     {pageLinks[props.currentPage-1]} 
                    {/* {pageLinks[props.currentPage]}
                    {pageLinks[props.currentPage+1]} */}
                    {props.currentPage < props.pages + 1 ? <li className={`page-item`} onClick={()=>props.nextPage(props.currentPage + 1)}><button className='page-link' >Next</button></li> : '' }
                    {props.currentPage < props.pages + 5 ? <li className={`page-item`} onClick={()=>props.nextPage(props.currentPage + 5)}><button className='page-link' ><i className="fas fa-forward"></i></button></li> : '' }
                    
                </ul>
            </div>
            
        </div>

    );
}

export default Pagination;
